<template>
	<div>
		<Loading v-if="loading" text="Lebenslauf wird geladen..."/>
		<template v-else>
			<div class="matching mb-4">
				<MatchingOverview
					:matching="matching"
					:with-percentage="false"
				/>
			</div>
			<slot name="after-matching-overview"/>
			<div class="job-vita">
				<Grid
					v-for="grid in vita.grids.filter(g => g.hasData)"
					:key="grid.id"
					:grid="grid"
					:job-profile-id="jobProfileId"
					:pseudonym-id="pseudonymId"
					@upgrade="loadVita"
				/>
			</div>
		</template>
	</div>
</template>

<script>
import Loading from "@/vue/common/Loading";
import Freetext from "@/vue/application/job/vita/Freetext";
import Grid from "@/vue/application/job/vita/Grid";
import Get from "@/api/job/vita/Get";
import MatchingOverview from "@/vue/customer/job-profile/applicant/MatchingOverview.vue";

export default {

	components: {
		MatchingOverview,
		Loading,
		Freetext,
		Grid,
	},

	props: {
		jobId: {
			type: String,
			required: true,
		},
		jobProfileId: {
			type: String,
			required: true,
		},
		pseudonymId: {
			type: String,
			required: false,
		},
	},

	mounted ()
	{
		this.loadVita();
	},

	data ()
	{
		return {
			loading: true,
			matching: null,
			vita: null,
			communication: null,
			gridProperties: [
				'job',
				'requirements',
				'common'
			],
		};
	},

	methods: {
		async loadVita ()
		{
			this.loading = true;

			const response = await new Get()
				.setJobId(this.jobId)
				.setJobProfileId(this.jobProfileId)
				.call();

			this.matching = response.data.matching;
			this.vita = response.data.vita;
			this.communication = response.data.communication;

			this.loading = false;

			this.$emit('loaded');
		}
	}
}
</script>
